import createApolloClient from '../../core/createApolloClient/createApolloClient.client';
import gql from 'graphql-tag';

const client = createApolloClient();

export async function createListingPhotos(vars) {
  try {
    let mutation = gql`
      mutation UploadListingPhotos(
        $listId: Int!
        $name: String
        $type: String
      ) {
        CreateListingPhotos(listId: $listId, name: $name, type: $type) {
          status
          photosCount
          id
          order
          name
        }
      }
    `;
    if (!vars.name || !vars.listId || !vars.type) {
      return 'savePhotosQL - Cannot save without valid parameters';
    }
    // Send Request to create a record for a listing
    const { data } = await client.mutate({
      mutation,
      variables: { listId: vars.listId, name: vars.name, type: vars.type },
    });

    if (
      data &&
      data.CreateListingPhotos &&
      data.CreateListingPhotos.status === 'success'
    ) {
      return data;
    }
  } catch (error) {
    console.log('savePhotosQL - failed to save', error);
    return false;
  }

  return false;
}

export async function removeListingPhotos(listId, name) {
  try {
    let mutation = gql`
      mutation RemoveListingPhotos($listId: Int!, $name: String) {
        RemoveListingPhotos(listId: $listId, name: $name) {
          status
          photosCount
        }
      }
    `;

    const { data } = await client.mutate({
      mutation,
      variables: { listId, name },
    });

    if (
      data &&
      data.RemoveListingPhotos &&
      data.RemoveListingPhotos.status === 'success'
    ) {
      // Remove file physically
      const resp = await fetch('/deletePhotos', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileName: name }),
        credentials: 'include',
      });
      const { status } = await resp.json();
      return status;
    }
  } catch (error) {
    console.log('Failed ot delete photo', error);
    return false;
  }

  return false;
}

export async function updateListingPhotoOrder(listId, items) {
  try {
    const mutation = gql`
      mutation UpdateListingPhotos(
        $listId: Int!
        $items: [ListingPhotosInput!]!
      ) {
        UpdateListingPhotoOrder(listId: $listId, items: $items) {
          status
        }
      }
    `;

    console.log('newItems', items);

    const newItems = items.map(x => ({
      id: x.id,
      listId,
      order: x.order || 0,
    }));

    console.log('savePhotosQL - updateListingPhotoOrder.js -', newItems);
    const { data } = await client.mutate({
      mutation,
      variables: { listId, items: newItems },
    });

    console.log('savePhotosQL - updateListingPhotoOrder.js -', data);

    if (
      data &&
      data.UpdateListingPhotoOrder &&
      data.UpdateListingPhotoOrder.status === 'success'
    ) {
      return data.updateListingPhotoOrder;
    }
  } catch (error) {
    console.log('failed to update photo order', error);
    return false;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/components_new/addListing/savePhotosQL.js